import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientesService } from '../../../services/clientes.service';
import { HelpersService } from '../../../services/tools/helpers.service';

@Component({
  selector: 'app-cliente-detalle',
  templateUrl: './cliente-detalle.component.html'
})
export class ClienteDetalleComponent implements OnInit {
  public cliente: any = {};
  public isLoading: boolean = false;
  public previewArchivos: any = {};
  public errors: any = [];
  public archivos: any = {};
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ClientesService,

    private helperService: HelpersService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.getDetalleCliente(+params['id']);
      }
    });
  }

  getDetalleCliente(id: number) {
    this.isLoading = true;
    this.service.getById(id).subscribe(
      (response: any) => {
        const data = response.json ? response.json().content : (response.content || response);

        // 1. Clonar el objeto para no perder los defaults
        let formValues = { ...this.cliente };

        // Limpiar estados previos de archivos para que no se queden cacheados de consultas anteriores
        this.archivos = {};

        // 2. Mapeo de datos planos (se asignan directo, ignorando relaciones complejas)
        Object.keys(data).forEach(key => {
          if (key !== 'perfil_fisico' && key !== 'perfil_moral' && key !== 'domicilios' && key !== 'documentos') {
            formValues[key] = data[key];
          }
        });

        // 3. Mapeo de Relaciones de Texto
        if (data.perfil_fisico) {
          Object.assign(formValues, data.perfil_fisico);
        }

        if (data.perfil_moral) {
          Object.assign(formValues, data.perfil_moral);
        }

        // 4. Mapeo de Domicilios (Estructura Actual vs Laboral)
        if (data.domicilios && Array.isArray(data.domicilios)) {
          data.domicilios.forEach((dom: any) => {
            if (dom.tipo_domicilio === 'ACTUAL') {
              Object.assign(formValues, {
                pais: dom.pais, estado: dom.estado, municipio: dom.municipio,
                cp: dom.cp, calle: dom.calle, num_exterior: dom.num_exterior,
                num_interior: dom.num_interior, colonia: dom.colonia
              });
            } else if (dom.tipo_domicilio === 'LABORAL') {
              Object.assign(formValues, {
                pais_laboral: dom.pais, estado_laboral: dom.estado, municipio_laboral: dom.municipio,
                cp_laboral: dom.cp, calle_laboral: dom.calle, num_exterior_laboral: dom.num_exterior,
                num_interior_laboral: dom.num_interior, colonia_laboral: dom.colonia
              });
            }
          });
        }

        // ====================================================================
        // 5. NUEVO: MAPEO DE EXPEDIENTE DIGITAL (documentos_clientes)
        // ====================================================================
        if (data.documentos && Array.isArray(data.documentos)) {
          data.documentos.forEach((doc: any) => {
            // Solo procesamos los archivos que estén activos (status === 1)
            if (doc.status === 1 || doc.status === '1') {
              // Opción A: Si tu HTML usa urls para mostrar links/previews (Recomendado)
              // Asignamos la ruta final al objeto que maneja la persistencia visual
              formValues[doc.tipo_documento] = doc.ruta_final;

              // 2. CORRECCIÓN: Asignamos el ID para la función de descarga
              // Si el tipo es 'ine_anverso', esto crea 'ine_anverso_id' = doc.id
              formValues[doc.tipo_documento + '_id'] = doc.id;
              // Opción B: Si necesitas almacenar metadata extra (ej. nombre original para pintarlo en la UI)
              // Creamos un almacén de previsualización dinámico
              if (!this.previewArchivos) { this.previewArchivos = {}; }
              this.previewArchivos[doc.tipo_documento] = {
                url: doc.ruta_final,
                nombreOriginal: doc.nombre_original,
                extension: doc.extension
              };

              console.log(`Documento cargado al formulario: ${doc.tipo_documento} ->`, doc.ruta_final);
            }
          });
        }
        // ====================================================================

        this.cliente = formValues;
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        this.helperService.httpGlobalError(error);
      }
    );
  }


}


// WEBPACK FOOTER //
// ./src/app/clientes/cliente-form/detalles/cliente-detalle.component.ts